import { render, staticRenderFns } from "./CoozzyFailIcon.vue?vue&type=template&id=6064c20c&scoped=true"
import script from "./CoozzyFailIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFailIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFailIcon.vue?vue&type=style&index=0&id=6064c20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064c20c",
  null
  
)

export default component.exports